export default {
  DYSLEXIA_PENDING: 'DYSLEXIA_PENDING',
  DYSLEXIA_COMPLETE: 'DYSLEXIA_COMPLETE',
  DYSLEXIA_ERROR: 'DYSLEXIA_ERROR',
  DYSLEXIA_SORT: 'DYSLEXIA_SORT',
  DYSLEXIA_CACHE_SAVE: 'DYSLEXIA_CACHE_SAVE',
}